export * from './FoodDrinkMilkIcon';
export * from './FoodDrinkMilkIcon16Light';
export * from './FoodDrinkMilkIcon16Regular';
export * from './FoodDrinkMilkIcon16Solid';
export * from './FoodDrinkMilkIcon20Light';
export * from './FoodDrinkMilkIcon20Regular';
export * from './FoodDrinkMilkIcon20Solid';
export * from './FoodDrinkMilkIcon24Regular';
export * from './FoodDrinkMilkIcon24Solid';
export * from './FoodDrinkMilkIcon32Regular';
export * from './FoodDrinkMilkIcon64Regular';
